__turbopack_context__.v({
  "copyLinkCopied": "CopyLink-module__qM40DW__copyLinkCopied",
  "copyLinkIcon": "CopyLink-module__qM40DW__copyLinkIcon",
});
